import * as React from 'react';
import {
    StarsRow,
    TestimonialAuthor,
    TestimonialBody,
    TestimonialCardFooter,
    TestimonialCardMain,
    TestimonialCardRoot,
    TestimonialTitle,
} from './MidnightMigrationScreen.style';

export interface MidnightMigrationTestimonialType {
    title: string;
    body: string;
    author: string;
}

export const MidnightMigrationTestimonialCard = (props: { item: MidnightMigrationTestimonialType }): JSX.Element => {
    const { item } = props;

    return (
        <TestimonialCardRoot>
            <TestimonialCardMain>
                <TestimonialTitle>{item.title}</TestimonialTitle>
                <TestimonialBody>{item.body}</TestimonialBody>
            </TestimonialCardMain>
            <TestimonialCardFooter>
                <StarsRow aria-hidden>★★★★★</StarsRow>
                <TestimonialAuthor>{item.author}</TestimonialAuthor>
            </TestimonialCardFooter>
        </TestimonialCardRoot>
    );
};
